export const CALLBACK_REDIRECT_KEY = 'callbackRedirect';
